import React, { Fragment } from 'react';
import CodeBlock, { TCodeBlockProps } from '@modules/ui/codeBlock/CodeBlock';
import StandardMarkdown from '@modules/ui/markdown/components/StandardMarkdown';
import processLuaCode from '../utils/processLuaCode';

const LuaCode = (
  props: {
    src: string;
    section?: string;
    raw?: boolean;
    showTitle?: boolean;
    description?: string;
    showDescription?: boolean;
  } & Omit<TCodeBlockProps, 'content'>,
) => {
  const {
    src,
    section,
    title,
    description,
    fullWidth = true,
    showTitle = true,
    showDescription = true,
    raw = false,
    enableCopy = true,
    enableExpand = true,
    ...otherProps
  } = props;

  const processedCode = processLuaCode(src, section);
  return raw ? (
    <Fragment>{processedCode}</Fragment>
  ) : (
    <Fragment>
      {showDescription && description && <StandardMarkdown>{description}</StandardMarkdown>}
      <CodeBlock
        content={processedCode}
        fullWidth={fullWidth}
        title={showTitle ? title : undefined}
        enableCopy={enableCopy}
        enableExpand={enableExpand}
        {...otherProps}
      />
    </Fragment>
  );
};

export default LuaCode;
